import { EXTREME_B2B_API_BASE_URL } from '../config';

// sessionStorage, not localStorage: this value is "which external page did
// THIS tab come from", which is inherently per-tab information. Keeping it
// in localStorage would let it leak between tabs running different accounts.
const RETURN_URL_KEY = 'external_app_referrer';

/**
 * Capture where to send the user back when an OAuth /validate session ends
 * (on logout, or when the code exchange itself fails) — called once from
 * the OAuth callback page, before authenticateWithCode's success-path
 * reload overwrites document.referrer.
 *
 * document.referrer is NOT reliable here — it's blank whenever the external
 * app links in via rel="noreferrer"/"noopener" (common for "open in new
 * tab" launch links), a strict Referrer-Policy, or an HTTPS->HTTP downgrade
 * (as happens testing a production platform against a local HTTP dev
 * server). The explicit returnUrl param is the only guaranteed signal;
 * referrer is kept only as a best-effort fallback.
 */
export function captureExternalReturnUrl(searchParams) {
  try {
    const explicit = searchParams.get('returnUrl') || searchParams.get('return_url');
    if (explicit) {
      sessionStorage.setItem(RETURN_URL_KEY, explicit);
      return explicit;
    }
    const referrer = document.referrer;
    if (referrer && new URL(referrer).origin !== window.location.origin) {
      sessionStorage.setItem(RETURN_URL_KEY, referrer);
      return referrer;
    }
  } catch (e) {
    // ignore malformed/inaccessible referrer or returnUrl
  }
  return null;
}

/** Reads and clears the captured return URL, if any. */
export function consumeExternalReturnUrl() {
  const url = sessionStorage.getItem(RETURN_URL_KEY);
  sessionStorage.removeItem(RETURN_URL_KEY);
  return url;
}

/**
 * Guaranteed destination for any OAuth-flow session/attempt: no session
 * that passed through /validate should ever be left on this app's own
 * login or error UI.
 */
export function getExternalFallbackUrl() {
  return EXTREME_B2B_API_BASE_URL;
}
